import Immutable from 'immutable';

import {
	// webapi,
	createModuleState,
	createModelForState,
	// REPORTED_EXCEPTION,
	// StaticLookup,
	setPreference,
	getPreference,
} from 'ps-gui';
import {
	createSearchModel,
	getSqlFulltextFilter,
	// parseRoleId
} from './utils';
import { getLookup } from '../data/lookup';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('CatalogRecording');

export default class CatalogRecordingModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	#setProperty(name, value) {
		if (Array.isArray(name)) {
			return new CatalogRecordingModel(this.#data.setIn(name, value));
		} else {
			return new CatalogRecordingModel(this.#data.set(name, value));
		}
	}

	setPartyId(partyId) {
		console.log('setPartyId', partyId);
		return this.#setProperty('partyId', partyId);
	}

	async checkGlobalContextChange(globalContext) {
		if (!globalContext) {
			return this;
		}
		const gcLangId = globalContext.getLanguageId();
		const langId = this.#data.get('langId');
		if (gcLangId === langId) {
			return this;
		}
		return (await this.initialize(globalContext)).#setProperty('languageTimestamp', new Date().getTime());
	}

	getLanguageTimestamp() {
		return this.#data.get('languageTimestamp') || 0;
	}

	async initializeLookups() {
		const producerId = getLookup('permanentCatalogProducer').getItems().getIn([0, 'key']);
		return this.setProducerId(producerId);
	}

	setProducerId(producerId) {
		let model = this.#setProperty('producerId', producerId);
		return model;
	}


	#getPreferenceKeyBase() {
		return '//myrec//';
	}

	#getExtFilterPreferenceKey() {
		return this.#getPreferenceKeyBase() + 'extFilter';
	}

	initializePreferences() {
		let data = this.#data;
		let ef = getPreference(this.#getExtFilterPreferenceKey());
		if (!ef) {
			return this;
		}
		const roleLookup = getLookup('permanentCatalogProducer');
		if (roleLookup) {
			const producerId = ef.get('producerId');
			if (producerId && roleLookup.getText(producerId)) {
				data = data.set('producerId', producerId);
			}
		}
		return new CatalogRecordingModel(data);
	}

	async initialize(globalContext) {
		console.log('inicializuji CatalogRecording');
		let model = await this.initializeLookups();
		let srch = createSearchModel('/api/dq/sv_permanent_catalog_recording').setFixedFilter({ producer_id: -1 }).setProcessFilter(processSearchFilter);
		srch = srch.setOutput(getSearchOutputColumns());
		srch = srch.initializePreferences();
		model = model.setSearch(srch);
		model = model.initializePreferences();
		model = await model.refreshSearch(true);
		return model.#setProperty('langId', globalContext.getLanguageId());
	}

	async refreshSearch(dontSavePreference) {
		const producerId = this.#data.get('producerId');
		if (!producerId) {
			return this;
		}
		let fixedFilter = {};
		if (!dontSavePreference && producerId) {
			setPreference(this.#getExtFilterPreferenceKey(), Immutable.Map({
				producerId,
			}));
		}
		fixedFilter.producer_id = producerId;

		let srch = this.getSearch().setFixedFilter(fixedFilter);
		srch = await srch.search(1);
		return this.setSearch(srch);
	}

	setSearch(model) {
		return new CatalogRecordingModel(this.#data.set('search', model.getState()));
	}

	getSearch() {
		return createModelForState(this.#data.get('search'));
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}
}

function processSearchFilter(filter) {
	if (filter.title) {
		filter.title = getSqlFulltextFilter(filter.title);
	}
	return filter;
}

export function getSearchOutputColumns(forExport) {
	if (forExport) {
		return [
			'recording_id',
			'title',
			'subtitle',
			'production_year',
			'release_year',
			'is_isrc_protocol',
			'length',
			'audio_video',
			'isrc'
		];
	} else {
		return [
			'title',
			'production_release_year',
			'length',
			'audio_video',
			'isrc'
		];
	}
}
